import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IKBCatalog } from '../interfaces/IBase-knowledge-catalog';
import { BaseKnowledgeCatalogService } from './base-knowledge-catalog.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogOperationsService {

  constructor(private _baseKnowledgeCatalogService: BaseKnowledgeCatalogService) { }

  validateAndSaveCatalog(catalog: IKBCatalog): Observable<any> {
    return new Observable(observer => {
      this._baseKnowledgeCatalogService.checkDisplayNameCatalogAvailable(catalog.Id, catalog.DisplayName).subscribe({
        next: (isAvailable) => {
          if (!isAvailable) {
            observer.error({ type: 'duplicate_name' });
            return;
          }
          this.saveCatalog(catalog).subscribe({
            next: (response) => observer.next(response),
            error: (error) => observer.error({ type: 'save_error', error }),
            complete: () => observer.complete()
          });
        },
        error: (error) => observer.error({ type: 'validation_error', error })
      });
    });
  }

  saveCatalog(catalog: IKBCatalog): Observable<any> {
    return this._baseKnowledgeCatalogService.saveCatalog(catalog);
  }

  deleteCatalog(catalog: IKBCatalog): Observable<any> {
    return this._baseKnowledgeCatalogService.deleteCatalog(catalog);
  }
}
